import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { Banco, BancoModalProps } from '../../types';

const BancoModal: React.FC<BancoModalProps> = ({ open, onClose, onSubmit, banco }) => {
  const [formData, setFormData] = useState<Banco>({
    id: 0,
    nome: '',
    host: '',
    database: '',
    username: '',
    data_expiracao: '',
    password: '',
  });

  useEffect(() => {
    if (banco) {
      setFormData(banco);
    } else {
      setFormData({
        id: 0,
        nome: '',
        host: '',
        database: '',
        username: '',
        data_expiracao: '',
        password: '',
      });
    }
  }, [banco, open]);

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          width: 400,
        }}
      >
        <Typography variant="h6" mb={2}>
          {banco ? 'Editar Banco' : 'Adicionar Banco'}
        </Typography>

        <TextField
          label="Subdominio"
          fullWidth
          value={formData.nome}
          onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Host"
          fullWidth
          value={formData.host}
          onChange={(e) => setFormData({ ...formData, host: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Banco"
          fullWidth
          value={formData.database}
          onChange={(e) => setFormData({ ...formData, database: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Usuário"
          fullWidth
          value={formData.username}
          onChange={(e) => setFormData({ ...formData, username: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Data Expiração"
          fullWidth
          type="date"
          value={formData.data_expiracao}
          onChange={(e) => setFormData({ ...formData, data_expiracao: e.target.value })}
          margin="normal"
        />
        
        {!banco && (
          <TextField
            label="Senha"
            fullWidth
            type="password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            margin="normal"
          />
        )}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button onClick={onClose} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            {banco ? 'Salvar' : 'Adicionar'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BancoModal;
